import React from 'react';
import { providerOverrideList } from 'api/appointmentSetting';
import { IproviderOverrideList } from 'types/appointmentSetting';
import { getUserId } from 'utils/localstore';
import dayjs from 'dayjs';

let globalData: IproviderOverrideList[] = [];

// 需要对override日期排序 默认是降序
const sortDate = (val: IproviderOverrideList[]) => {
    val.sort((a, b) => dayjs(b.overrideDate).valueOf() - dayjs(a.overrideDate).valueOf());
};

const useOverride = (providerId?: number, scheduleToken?: string): [IproviderOverrideList[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    // a specific providerId (switched-provider flow) bypasses the shared admin cache
    const [items, setItems] = React.useState<IproviderOverrideList[]>(providerId ? [] : globalData);
    const fetchData = async () => {
        try {
            setLoading(true);
            const uid = providerId ?? getUserId();
            const result = await providerOverrideList(uid, scheduleToken);
            if (!result.error) {
                const data: IproviderOverrideList[] = result?.data?.data || [];
                sortDate(data);
                if (!providerId) {
                    globalData = data;
                }
                setItems(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (providerId) {
            fetchData();
            return;
        }
        if (!items || Object.keys(items).length === 0) {
            if (!loading) {
                fetchData();
            }
        }
    }, []);

    return [items, loading, fetchData];
};

export default useOverride;
